const translation = {
  currentPlan: '現在のプラン',
  upgradeBtn: {
    plain: 'プランをアップグレード',
    encourage: '今すぐアップグレード',
    encourageShort: 'アップグレード',
  },
  viewBilling: '請求とサブスクリプションの管理',
  buyPermissionDeniedTip: 'サブスクリプションするには、エンタープライズ管理者に連絡してください',
  plansCommon: {
    title: 'あなたに合ったプランを選択してください',
    yearlyTip: '年間購読で2か月無料！',
    mostPopular: '最も人気のある',
    planRange: {
      monthly: '月額',
      yearly: '年額',
    },
    month: '月',
    year: '年',
    save: '節約 ',
    free: '無料',
    currentPlan: '現在のプラン',
    contractSales: '営業に連絡する',
    contractOwner: 'チームマネージャーに連絡する',
    startForFree: '無料で始める',
    getStartedWith: '始める ',
    contactSales: '営業に連絡する',
    talkToSales: '営業と話す',
    modelProviders: 'モデルプロバイダー',
    teamMembers: 'チームメンバー',
    buildApps: 'アプリを作成する',
    vectorSpace: 'ベクトルスペース',
    vectorSpaceBillingTooltip: '1MBあたり約120万文字のベクトル化データを保存できます（OpenAI Embeddingsを使用して推定され、モデルによって異なります）。',
    vectorSpaceTooltip: 'ベクトルスペースは、LLMがデータを理解するために必要な長期記憶システムです。',
    documentProcessingPriority: 'ドキュメント処理の優先度',
    documentProcessingPriorityTip: 'より高いドキュメント処理の優先度をご希望の場合は、プランをアップグレードしてください。',
    documentProcessingPriorityUpgrade: 'より高い精度と高速な速度でデータを処理します。',
    priority: {
      'standard': '標準',
      'priority': '優先',
      'top-priority': '最優先',
    },
    logsHistory: 'ログ履歴',
    customTools: 'カスタムツール',
    unavailable: '利用不可',
    days: '日',
    unlimited: '無制限',
    support: 'サポート',
    supportItems: {
      communityForums: 'コミュニティフォーラム',
      emailSupport: 'メールサポート',
      priorityEmail: '優先メール＆チャットサポート',
      logoChange: 'ロゴ変更',
      SSOAuthentication: 'SSO認証',
      personalizedSupport: '個別サポート',
      dedicatedAPISupport: '専用APIサポート',
      customIntegration: 'カスタム統合とサポート',
      ragAPIRequest: 'RAG APIリクエスト',
      agentMode: 'エージェントモード',
      workflow: 'ワークフロー',
    },
    comingSoon: '近日公開',
    member: 'メンバー',
    memberAfter: 'メンバー',
    messageRequest: {
      title: 'メッセージクレジット',
      tooltip: 'OpenAIモデルを使用したさまざまなプランのメッセージ呼び出しクォータ（gpt4を除く）。制限を超えるメッセージはOpenAI APIキーを使用します。',
    },
    annotatedResponse: {
      title: '注釈クォータ制限',
      tooltip: '手動での編集と応答の注釈付けにより、アプリのカスタマイズ可能な高品質な質問応答機能が提供されます（チャットアプリのみ適用）。',
    },
    ragAPIRequestTooltip: 'Difyのナレッジベース処理機能のみを呼び出すAPI呼び出しの数を指します。',
    receiptInfo: 'チームオーナーとチーム管理者のみが購読および請求情報を表示できます',
  },
  plans: {
    sandbox: {
      name: 'サンドボックス',
      description: 'GPTの無料トライアル200回',
      includesTitle: '含まれるもの：',
    },
    professional: {
      name: 'プロフェッショナル',
      description: '個人や小規模チーム向けにより多くのパワーを手頃な価格で提供します。',
      includesTitle: '無料プランに加えて、次も含まれます：',
    },
    team: {
      name: 'チーム',
      description: '制限なく協力し、最高のパフォーマンスを楽しむ。',
      includesTitle: 'プロフェッショナルプランに加えて、次も含まれます：',
    },
    enterprise: {
      name: 'エンタープライズ',
      description: '大規模なミッションクリティカルシステムのためのフル機能とサポートを提供します。',
      includesTitle: 'チームプランに加えて、次も含まれます：',
    },
  },
  vectorSpace: {
    fullTip: 'ベクトルスペースがいっぱいです。',
    fullSolution: 'より多くのスペースを得るためにプランをアップグレードしてください。',
  },
  apps: {
    fullTipLine1: 'より多くのアプリを作成するには、',
    fullTipLine2: 'プランをアップグレードしてください。',
  },
  annotatedResponse: {
    fullTipLine1: 'より多くの会話を注釈するには、',
    fullTipLine2: 'プランをアップグレードしてください。',
    quotaTitle: '注釈返信クォータ',
  },
  monthlyBillOverview: {
    title: '月次請求概要',
    monthSelector: '請求月：',
    overview: '月次概要',
    overviewTitle: '月概要',
    billingCycle: '請求サイクル：',
    to: 'から',
    status: {
      billed: '請求済み',
      pending: '請求中',
    },
    exportBill: '請求書をエクスポート',
    exportSuccess: 'エクスポート成功',
    exportError: 'エクスポート失敗、後でもう一度お試しください',
    payableAmount: '支払金額',
    tabs: {
      accountSummary: 'リソース購入アカウント別サマリー',
      productSummary: '製品別サマリー',
    },
    table: {
      resourcePurchaseAccount: 'リソース購入アカウント',
      billingPeriod: '請求期間',
      catalogTotalPrice: 'カタログ総額（原価）',
      discountedPrice: '割引価格',
      voucherDeduction: 'バウチャー控除',
      payableAmount: '支払金額',
      productType: '製品タイプ',
      billingMode: '課金モード',
      feeType: '料金タイプ',
      prepaid: 'プリペイド',
      postpaid: 'ポストペイド',
    },
  },
  monthlyBillHistory: {
    title: '月次請求履歴',
    billingPeriod: '請求期間：',
    resourcePurchaseAccount: 'リソース購入アカウント：',
    dateRangePlaceholder: {
      startMonth: '開始月',
      endMonth: '終了月',
    },
    maxQueryWarning: '最大12ヶ月のデータを照会できます',
    table: {
      resourcePurchaseAccount: 'リソース購入アカウント',
      billingPeriod: '請求期間',
      catalogTotalPrice: 'カタログ総額（原価）',
      discountedPrice: '割引価格',
      voucherDeduction: 'バウチャー控除',
      payableAmount: '支払金額',
      status: 'ステータス',
      action: '操作',
      detail: '詳細',
    },
    status: {
      billed: '請求済み',
      pending: '請求中',
    },
    pagination: {
      total: '合計 {total} 件',
    },
  },
}

export default translation
